import { ListBox } from "@heroui/react";
import { InlineSelect } from "@heroui-pro/react";

import type { FilterOption } from "./filters";

/** A filter that sits in a toolbar as plain text, "Supplier  All v", and opens a list on press. */
export function InlineFilterSelect({
  label,
  value,
  options,
  onChange,
  allLabel = "All",
}: {
  label: string;
  value: string | null;
  options: FilterOption[];
  onChange: (value: string | null) => void;
  allLabel?: string;
}) {
  return (
    <InlineSelect
      aria-label={label}
      selectedKey={value ?? "__all"}
      onSelectionChange={(key) =>
        onChange(key === "__all" || key === null ? null : String(key))
      }
    >
      <InlineSelect.Trigger>
        <span className="text-muted">{label}</span>
        <InlineSelect.Value />
        <InlineSelect.Indicator />
      </InlineSelect.Trigger>
      <InlineSelect.Popover>
        <ListBox>
          {[{ id: "__all", label: allLabel }, ...options].map((option) => (
            <ListBox.Item
              key={option.id}
              id={option.id}
              textValue={option.label}
            >
              {option.label}
              <ListBox.ItemIndicator />
            </ListBox.Item>
          ))}
        </ListBox>
      </InlineSelect.Popover>
    </InlineSelect>
  );
}
